import { SearchParameterOptionsType } from 'src/lib/types/random'

export const ROWS_PER_PAGE = 20

export const searchParameterOptions: SearchParameterOptionsType[] = [
  {
    value: 'name_like',
    label: 'By Name',
    placeholder: 'Search product...'
  },
  {
    value: 'sku_like',
    label: 'By SKU',
    placeholder: 'Search product...'
  }
]
